import {TPurchaseOrderOptions} from './ao-order-purchase-order.type';

//#region INTERFACE IOpenOrderFilterSettings
export interface IOpenOrderFilterSettings {
  orderQuantityGreaterThanZero: boolean;
  purchaseOrders: TPurchaseOrderOptions;
  suggestionGreaterThanZero: boolean;
  selectedLineColors?: string[];
}

//#endregion
